var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8994 0C5.37941 0 0.899414 4.48 0.899414 10C0.899414 15.52 5.37941 20 10.8994 20C16.4194 20 20.8994 15.52 20.8994 10C20.8994 4.48 16.4194 0 10.8994 0ZM8.89941 15L3.89941 10L5.30941 8.59L8.89941 12.17L16.4894 4.58L17.8994 6L8.89941 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheck);
export default __webpack_public_path__ + "static/media/whiteCheck.2a79ad321984c0c78c7614853822d568.svg";
export { ForwardRef as ReactComponent };